// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media (1600px <= width) {
    .group-members-list__grid {
        display: grid;
        grid-template-columns: auto auto;
    }
}

@media (1220px < width < 1600px) {
    .group-members-list__grid {
        display: grid;
        grid-template-columns: auto auto;
    }
}
@media (width <= 1220px) {
    .group-members-list__grid {
        display: block;
        max-width: 400px;
        margin: 0 auto;
    }
}
`, "",{"version":3,"sources":["webpack://./client/components/groups/members/GroupMembersList/GroupMembersList.css"],"names":[],"mappings":";AACA;IACI;QACI,aAAa;QACb,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,aAAa;QACb,gCAAgC;IACpC;AACJ;AACA;IACI;QACI,cAAc;QACd,gBAAgB;QAChB,cAAc;IAClB;AACJ","sourcesContent":["\n@media (1600px <= width) {\n    .group-members-list__grid {\n        display: grid;\n        grid-template-columns: auto auto;\n    }\n}\n\n@media (1220px < width < 1600px) {\n    .group-members-list__grid {\n        display: grid;\n        grid-template-columns: auto auto;\n    }\n}\n@media (width <= 1220px) {\n    .group-members-list__grid {\n        display: block;\n        max-width: 400px;\n        margin: 0 auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
